import { useEffect, useRef, useState } from "react";
import { Col, Row } from "react-bootstrap";
import { Field } from "react-final-form";
import { useTranslation } from "react-i18next";
import BMXSelectField from "../../../../../Components/Inputs/BMXSelectField/BMXSelectField";
import BMXTextField from "../../../../../Components/Inputs/BMXTextField/BMXTextField";
import BMXSeparator from "../../../../../Components/Separator/BMXSeparator";
import { GlobalAuthFetch } from "../../../../../Utils/GlobalAuthFetch/GlobalAuthFetch";
import { updateDashboardByName } from "../../../../../Utils/Sockets";
import BMXAsynchronous from "../../../../../Components/Inputs/BMXAsynchronous/BMXAsynchronous";
import { useDispatch } from "react-redux";
import { show } from "redux-modal";
import { clientTypes } from "../../../../../Utils/GlobalVariables/Crm/ClientTypes";
import BMXAutocomplente from "../../../../../Components/Inputs/BMXAutocomplete/BMXAutocomplete";
import { useContacts } from "../../../../../Hooks/useContactsHook/useContacts";

import BMXDatePicker from "../../../../../Components/Inputs/BMXDatePicker/BMXDatePicker";

const SecretFormStepOne = ({ allTechnicians, ...props }) => {
  const { update, initialValues } = props;
  console.log("initialValues en step one", initialValues);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  const [contacts, setContacts] = useState([]);
  const { getContactData } = useContacts();

  const { values, form } = props;

  const loadData = async (searchTerm) => {
    if (searchTerm?.length > 0) {
      const data = GlobalAuthFetch({
        path: `/contact/findByName/${searchTerm}`,
      });
      const [contactListPayload] = await Promise.all([data]);
      const contactList = contactListPayload?.payload?.data?.map((contact) => {
        return {
          uuid: contact.uuid,
          value: `${contact.name}`,
          ...contact,
        };
      });

      if (contactList?.length > 0) {
        setContacts(contactList);
        return contactList;
      } else {
        setContacts([]);
        return [];
      }
    }
  };

  const prevClientUuid = useRef();

  useEffect(() => {
    const current = values?.client?.uuid;

    if (prevClientUuid.current && prevClientUuid.current !== current) {
      form.change("clientRepresentative", null);
    }

    prevClientUuid.current = current;
  }, [values?.client?.uuid]);

  // useEffect(() => {
  //   const fetchData = async () => {};
  //   fetchData();
  // }, []);

  return (
    <div className="SecretFormStepOne" style={{ justifyContent: "flex-start" }}>
      <BMXSeparator title={t("global:client.basicInformation")} />
      <Row>
        <Col xs={12}>
          <Field
            component={BMXAsynchronous}
            label={`${t("global:secret.client")}`}
            name="client"
            data-cy="client"
            options={contacts}
            currentValues={values}
            getOptionLabel={(option) => {
              if (option.name) return option.name;
              return option;
            }}
            getData={loadData}
            afterIcon="add"
            afterIconSize="13px"
            afterIconClick={() => {
              const updateTableRegistry = () =>
                updateDashboardByName("contact");
              dispatch(
                show("ContactsModal", {
                  updateTableRegistry,
                  header: t("global:contacts.add"),
                  loadData,
                }),
              );
            }}
          />
        </Col>
        <Col xs={12}>
          <Field
            name="clientRepresentative"
            data-cy="clientRepresentative"
            beforeIcon="people"
            afterIcon="add"
            afterIconSize="18px"
            afterIconClick={() => {
              const contactUuid = values?.client?.uuid || values?.client?.value;
              const updateSingleRegistry = () =>
                updateDashboardByName("contact", contactUuid);
              dispatch(
                show("RepresentativesModal", {
                  loadData: async () => {
                    await getContactData(values?.client?.name);
                  },
                  header: t("global:contact.representativeAdd"),
                  updateSingleRegistry,
                  uuid: contactUuid,
                }),
              );
            }}
            disabled={!values?.client}
            component={BMXAutocomplente}
            currentValues={values}
            options={values?.client?.representatives?.map((el) => ({
              value: el.uuid,
              uuid: el.uuid,
              name: el.name,
              lastname: el.lastname,
              label: `${el.name || ""} ${el.lastname || ""}`,
              email: el.email,
              phoneNumber: el.phoneNumber,
            }))}
            label={`${t("global:secret.clientRepresentative")}`}
            renderValue={(el) => {
              const fullName = [el?.name, el?.lastname]
                .filter(Boolean)
                .join(" ");

              return [fullName, el?.email, el?.phoneNumber]
                .filter(Boolean)
                .join(" · ");
            }}
            // renderSecondary={(e) => (
            //   <>
            //     {e?.email && <div>{e.email}</div>}
            //     {e?.phoneNumber && <div>{e.phoneNumber}</div>}
            //   </>
            // )}
          />
        </Col>
        <Col xs={12}>
          <Field
            data-cy="customerServiceRepresentative"
            component={BMXSelectField}
            values={allTechnicians}
            label={`${t("global:secret.customerServiceRepresentative")}`}
            name="customerServiceRepresentative"
            renderValue={(el) => {
              return `${el.name || ""} ${el.lastname || ""}`;
            }}
          />
        </Col>
        <Col xs={6}>
          <Field
            name="contractStartDate"
            component={BMXDatePicker}
            label={t("global:secret.contractStartDate")}
          />
        </Col>
        <Col xs={6}>
          <Field
            name="contractEndDate"
            component={BMXDatePicker}
            label={t("global:secret.contractEndDate")}
          />
        </Col>
        <Col xs={12}>
          <Field
            name="comments"
            label={`${t("global:secret.comments")}`}
            component={BMXTextField}
            data-cy="comments"
            maxRows={4}
            multiline={true}
          />
        </Col>
      </Row>
    </div>
  );
};

export default SecretFormStepOne;
